<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card :loading="loading">
             <v-card-title class="pb-5 report-card-title mb-8" v-if="$vuetify.breakpoint.smAndDown">
  <span class="report-title">
    {{ $t($route.meta.title) }}
  </span>

  <v-btn
    type="button"
    class="btn-back rounded-lg"
    @click="$router.push('/home')"
  >
    <span class="flaticon2-reply icon-lg"></span>
    بازگشت
  </v-btn>

  <v-btn
    type="button"
    class="submit-btn rounded-lg mb-10"
    :loading="loading"
    :disabled="loading"
    @click.stop.prevent="addWorkReports"
  >
    <span class="fa fa-bookmark icon-md ml-1 "></span>
    ذخیره
  </v-btn>
</v-card-title>

              <v-card-title class="pb-5" v-else>
                <!--                                    v-if="$can('transaction_create')"-->
                <v-btn @click="$router.push('/home')" class="btn-back">
                  <span class="flaticon2-reply icon-lg"></span>
                  بازگشت
                </v-btn>
                <span class="report-title">
                    {{ $t($route.meta.title) }}
                  </span>
                <v-btn
                  @click.stop.prevent="addWorkReports"
                  class="submit-btn"
                  :loading="loading"
                >
                  <span class="fa fa-bookmark icon-md ml-1"></span>
                  ذخیره
                </v-btn>
                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <date-picker
                      v-model="started_at"
                      label="ساعت شروع"
                      format="YYYY-MM-DD HH:mm"
                      type="time"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      outlined
                      simple
                      dense
                    >
                    </date-picker>
                    <div v-if="errors.length !== 0">
                      <p
                        class="mt-2 text-danger"
                        v-if="errors.started_at"
                        v-for="(des, ind) in errors.started_at"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <date-picker
                      v-model="expired_at"
                      label="ساعت پایان"
                      :max="expired_at"
                      format="YYYY-MM-DD HH:mm"
                      type="time"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      outlined
                      simple
                      dense
                    >
                    </date-picker>
                    <div v-if="errors.length !== 0">
                      <p
                        class="mt-2 text-danger"
                        v-if="errors.expired_at"
                        v-for="(des, ind) in errors.expired_at"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="learning_time"
                      @keypress="isNumberKey"
                      :error-messages="
                        errors !== [] ? errors.learning_time : ''
                      "
                      type="text"
                      maxlength="2"
                      label="زمان صرف شده برای آموزش(بر حسب ساعت)"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-radio-group
                      :error-messages="
                        errors !== [] ? errors.company_presence : ''
                      "
                      v-model="row"
                      row
                    >
                      <v-radio label="حضور در شرکت" value="present"></v-radio>
                      <v-radio label="دورکاری" value="telecommuting"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-checkbox
                      label="مرخصی ساعتی"
                      v-model="vacation"
                    ></v-checkbox>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-checkbox
                      label="کارکرد ساعتی"
                      v-model="hourly"
                    ></v-checkbox>
                  </v-flex>
                </v-row>

                <v-row v-if="hourly">
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2" v-if="hourly">
                    <v-text-field
                      v-model="endHour"
                      @keypress="isNumberKey"
                      :error-messages="errors !== [] ? errors.end_hour : ''"
                      type="text"
                      maxlength="2"
                      label="دقیقه"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2" v-if="hourly">
                    <v-text-field
                      v-model="startHour"
                      @keypress="isNumberKey"
                      :error-messages="errors !== [] ? errors.start_hour : ''"
                      type="text"
                      maxlength="2"
                      label="ساعت"
                      outlined
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-row>

                <v-row v-if="vacation">
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2" v-if="vacation">
                    <date-picker
                      v-model="vacation_started_at"
                      label="ساعت شروع مرخصی"
                      format="YYYY-MM-DD HH:mm"
                      type="time"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      outlined
                      dense
                    >
                    </date-picker>
                  </v-flex>

                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2" v-if="vacation">
                    <date-picker
                      v-model="vacation_expired_at"
                      label="  ساعت پایان مرخصی"
                      format="YYYY-MM-DD HH:mm"
                      type="time"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      outlined
                      dense
                    >
                    </date-picker>
                  </v-flex>
                </v-row>

                <v-row>
                  <v-flex class="p-2">
                    <div v-if="errors.length !== 0">
                      <p
                        class="mt-2 text-danger"
                        v-if="errors.description"
                        v-for="(des, ind) in errors.description"
                        :key="ind"
                      >
                        {{ des }}
                      </p>
                    </div>
                    <ckeditor
                      :editor="editor.editor"
                      v-model="description"
                      :config="editor.editorConfig"
                    ></ckeditor>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import smsTariffPicker from "@/view/pages/pickers/smsTariffPicker";
import priceInput from "@/view/pages/pickers/priceInput";
import subLinePicker from "@/view/pages/pickers/subLinePicker";
import permissionPicker from "@/view/pages/pickers/permissionPicker";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import userPicker from "@/view/pages/pickers/userPicker";

export default {
  components: { userPicker, priceInput },
  data() {
    return {
      service: [],
      services: [],
      users: [],
      title: null,
      shouldExpireAt: null,
      vacation: false,
      hourly: false,
      startHour: null,
      endHour: null,
      vacation_started_at: null,
      vacation_expired_at: null,
      learning_time: 0,
      started_at: this.time,
      row: null,
      picture: null,
      code: null,
      target: null,
      price_max: 0,
      expire: null,
      usable: 0,
      permissions: {},
      roleid: null,
      point: null,
      loading: false,
      discount: null,
      time: null,
      expired_at: null,
      tariff: {},
      rb: {
        rb: {
          number: null,
          chat: null,
          new: null,
          unique: null,
        },
      },
      subline: {},
      tariffs: [],
      owner: { id: null },
      show: { id: null },
      sortOrder: null,
      features: [],
      description: null,
      roles: [],
      errors: [],
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
      rules: {
        title: [
          (val) => (val || "").length > 0 || "فیلد عنوان الزامی می باشد.",
        ],
        services: [(val) => val.length > 0 || "فیلد سرویس الزامی می باشد."],
        price: [(val) => (val || "").length > 0 || "فیلد قیمت الزامی می باشد."],
        expire: [
          (val) => (val || "").length > 0 || "فیلد تاریخ انقضا الزامی می باشد.",
        ],
        // permissions: [val => (val || []).length > 0 || 'فیلد دسترسی الزامی می باشد.'],
        // tariff: [val => !!val || 'فیلد تعرفه الزامی می باشد.'],
      },
    };
  },

  created() {
    this.info();
    this.requestApiGet("nowTime").then(({ data }) => {
      // this.shouldExpireAt=data.nowTime
      this.started_at = data.started_at;
      this.expired_at = data.nowTime;
    });

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },
  watch: {
    vacation(value) {
      if (!value) {
        this.vacation_started_at = null;
        this.vacation_expired_at = null;
      }
    },
  },

  methods: {
    getPacks() {
      this.requestApiGet("pack").then(({ data }) => {
        this.services = data.data;
      });
    },

    addWorkReports() {
      this.loading = true;
      let data;

      if (this.vacation) {
        if (this.hourly) {
          data = {
            started_at: this.started_at,
            expired_at: this.expired_at,
            learning_time: this.learning_time,
            start_vacation: this.vacation_started_at,
            end_vacation: this.vacation_expired_at,
            vacation: this.vacation,
            company_presence: this.row,
            description: this.description,
            hourly: true,
            start_hour: this.startHour,
            end_hour: this.endHour,
          };
        } else {
          data = {
            started_at: this.started_at,
            expired_at: this.expired_at,
            learning_time: this.learning_time,
            start_vacation: this.vacation_started_at,
            end_vacation: this.vacation_expired_at,
            vacation: this.vacation,
            company_presence: this.row,
            description: this.description,
          };
        }
      } else {
        if (this.hourly) {
          data = {
            started_at: this.started_at,
            expired_at: this.expired_at,
            learning_time: this.learning_time,
            company_presence: this.row,
            description: this.description,
            hourly: true,
            start_hour: this.startHour,
            end_hour: this.endHour,
          };
        } else {
          data = {
            started_at: this.started_at,
            expired_at: this.expired_at,
            learning_time: this.learning_time,
            company_presence: this.row,
            description: this.description,
          };
        }
      }

      this.requestApiPost("workReports", data)
        .then((response) => {
          this.loading = false;
          this.$toast.success("گزارش کار جدید با موفقیت ایجاد شد.");
          this.$router.push({ name: "home" });
        })
        .catch(({ response }) => {
          this.loading = false;
          this.errors = response.data.errors;
          if (response.data.errors.today) {
            this.$toast.error(response.data.errors.today[0]);
          }
        });

      // if (this.vacation){
      //   this.requestApiPost('workReports', {
      //     started_at: this.started_at,
      //     expired_at: this.expired_at,
      //     learning_time: this.learning_time,
      //     start_vacation:this.vacation_started_at,
      //     end_vacation:this.vacation_expired_at,
      //     vacation:this.vacation,
      //     company_presence:this.row,
      //     description: this.description,
      //   }).then(response => {
      //     this.loading=false
      //     this.$toast.success('گزارش کار جدید با موفقیت ایجاد شد.');
      //     this.$router.push({name: 'home'});
      //   }).catch(({response}) => {
      //     this.errors = response.data.errors;
      //     this.loading=false
      //   });
      // }
      // else{
      //
      // }
    },
    info() {
      this.$toast.info("لطفا قبل از نوشتن گزارش روی دکمه لیست عددی کلیک کنید.");
    },
    setEdited(x) {
      x.edited = true;
    },
    createRegister() {
      this.register.push({
        organName: "",
        type: null,
        date: "",
      });
    },
    picked(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files.length >= 1) {
        this.picture = files[0];
        let avatarBlock = document.getElementById("avatar-block");
        let fileReader = new FileReader();
        fileReader.onload = function (e) {
          let preview = avatarBlock.getElementsByClassName("v-image__image")[0];
          preview.style.backgroundImage = "url('" + this.result + "')";
          preview.style.display = "block";
        };
        fileReader.readAsDataURL(files[0]);
      }
    },
    isNumberKey: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    addCount() {
      this.features.push({
        id: this.features.length + 1,
        key: null,
        value: null,
      });
    },
    decreaseCount() {
      if (this.features.length > 0) {
        this.features.pop();
      }
    },
  },
};
</script>
<style scoped>
::v-deep .ck-editor__editable, 
::v-deep .v-text-field input, 
::v-deep .v-text-field textarea {
  -webkit-user-select: text !important;
  -moz-user-select: text !important;
  -ms-user-select: text !important;
  user-select: text !important;
}

::v-deep .ck-editor__editable {
  touch-action: manipulation;
}
.report-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: nowrap;
}

.report-title {
  flex: 1;
  min-width: 0;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.btn-back,
.submit-btn {
  flex-shrink: 0;
}

@media (max-width: 600px) {
  .report-card-title {
    padding: 12px 8px !important;
    gap: 4px;
  }

  .report-card-title .v-btn {
    min-width: auto !important;
    padding: 0 8px !important;
  }

  .report-title {
    font-size: 13px;
  }
}
.report-card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.report-title {
  flex: 1;
  min-width: 0;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.btn-back,
.submit-btn {
  flex-shrink: 0;
}

@media (max-width: 600px) {
  .report-card-title {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 12px 8px !important;
    gap: 8px; /* فاصله ۸ پیکسل بین عنوان، بازگشت و ذخیره */
  }

  .report-title {
    order: 1;
    flex: none;
    width: 100%;
    text-align: center;
    white-space: normal;
    overflow: visible;
    text-overflow: initial;
  }

  .btn-back {
    order: 2;
  }

  .submit-btn {
    order: 3;
  }

  .report-card-title .v-btn {
    width: 100%;
    min-width: 100% !important;
    margin: 0 !important;
  }
}
@media (max-width: 600px) {
  .report-card-title {
    padding-bottom: 8px !important;
  }
}
</style>
